export const generateRandomData = (length) => {
    const quota = 65536;
    const data = new Uint8Array(length);
    for (let i = 0; i < length; i += quota) {
        crypto.getRandomValues(data.subarray(i, i + Math.min(length - i, quota)));
    }
    return data;
};
export function generateRandomString(len) {
    const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; ++i) {
        const position = Math.floor(Math.random() * charSet.length);
        randomString += charSet.at(position);
    }
    return randomString;
}
